import nextI18NextConfig from '../next-i18next.config';

export const WHITE_LABEL_NAME_OPTION = 'whiteLabelName';

/**
 * "White Label": the name of the product of the workspace instead of "DataDoc" in every translated text.
 * The name lives in the options of the i18n instance of the request (next-i18next creates a clone for each request on the server),
 * so the requests of the different workspaces do not mix.
 */
export const whiteLabelPostProcessor = {
  type: 'postProcessor',
  name: 'whiteLabelName',
  process: (value, key, options, translator) => {
    const name = translator?.options?.[WHITE_LABEL_NAME_OPTION];
    return name && typeof value === 'string' ? value.replaceAll('DataDoc', name) : value;
  },
};

export const i18nConfig = { ...nextI18NextConfig, use: [whiteLabelPostProcessor], postProcess: ['whiteLabelName'] };
